import { Button } from "@2u-landing-pages/components";
import { Container, Heading, Subhead } from "@red-digital/bricks";
import { useState } from "react";

const colorConfig = [
  {
    group: "School Text Colors",
    colors: [
      "--text-primary-1",
      "--text-primary-2",
      "--text-primary-3",
      "--text-primary-4",
      "--text-primary-5",
      "--text-primary-6",
    ],
  },
  {
    group: "Global Text Colors",
    colors: [
      "--text-neutral-dark",
      "--text-neutral-inverse-dark",
      "--text-neutral-inverse-light",
      "--text-neutral-light",
      "--text-neutral-mid",
    ],
  },
  {
    group: "School Surface Colors",
    colors: ["--surface-primary-1", "--surface-primary-2", "--surface-primary-3", "--surface-primary-4"],
  },
  {
    group: "Global Surface Colors",
    colors: [
      "--surface-neutral-black",
      "--surface-neutral-dark",
      "--surface-neutral-light",
      "--surface-neutral-mid",
      "--surface-neutral-white",
    ],
  },
];

interface ColorPreviewProps {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

const ColorPreview: React.FC<ColorPreviewProps> = ({ enabled, setEnabled }) => {
  return (
    <div
      style={{
        background: "#fff",
        position: "fixed",
        top: "0",
        left: 0,
        width: "100vw",
        padding: "32px",
        textAlign: "left",
        gap: "60px",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.25)",
      }}
    >
      <Container flex>
        <Button
          size="small"
          color="dark"
          onClick={() => setEnabled(!enabled)}
          iconSelection={{ icon: "x" }}
          style={{
            position: "absolute",
            right: "32px",
            top: "10px",
            aspectRatio: "1/1",
            padding: "10px",
            display: "block",
            borderRadius: "4px",
          }}
        />
        {colorConfig.map((group) => (
          <div key={group.group} style={{ flex: "1 1 25%", gap: "50px" }}>
            <Subhead variant="subhead-sm" modifier={700}>
              {group.group}
            </Subhead>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              {group.colors.map((color) => (
                <li
                  key={color}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      background: `var(${color})`,
                      width: "30px",
                      height: "30px",
                      margin: "5px",
                      border: "1px solid #000",
                    }}
                  ></div>
                  <span>{color}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Container>
    </div>
  );
};

interface PreviewModeProps {
  internal?: boolean;
}

export const PreviewMode: React.FC<PreviewModeProps> = ({ internal }) => {
  const [enabled, setEnabled] = useState(false);

  return (
    <>
      <button
        style={{
          background: "#eed202",
          textAlign: "center",
          padding: "10px",
          fontWeight: 700,
          fontSize: "20px",
          position: "fixed",
          top: "200px",
          left: "-45px",
          zIndex: 1000,
          transform: "rotate(90deg)",
          cursor: "pointer",
        }}
        onClick={() => setEnabled(!enabled)}
      >
        <Heading style={{}} variant="heading-sm" modifier={600}>
          Preview Mode
        </Heading>
      </button>
      {enabled && <ColorPreview enabled={enabled} setEnabled={setEnabled} />}
    </>
  );
};
